import React from 'react'

import './index.css'

import { 
    Input,
    Card
} from 'antd'

import { 
    setStyleSheet
} from '../../actions'
import { connect } from 'react-redux'

class StyleSheetEditor extends React.Component {
    render(){

        if( this.props.loading) {
            return "loading..."
        }

        return (
            <div>
                <div className="stylesheet-title">
                    index.css
                </div>
                <div className="stylesheet-editor">
                    <Input.TextArea
                        defaultValue={this.props.styleSheet}
                        id="textarea"
                        onChange={this.handleChange}
                        rows={500}
                    />
                </div>
            </div>
        )
    }

    handleChange = (e) => {
        this.props.setStyleSheet(e.target.value)
    }
}

export default connect(
    state => ({
        styleSheet: state.categoryFeatures.activeCategoryFeature.styleSheet,
        loading: state.categoryFeatures.loading
    }),
    dispatchEvent => ({
        setStyleSheet: (styleSheet) => dispatchEvent(setStyleSheet( styleSheet ))
    })
)(StyleSheetEditor)


// WEBPACK FOOTER //
// ./src/components/category-feature/editor/stylesheet-editor/index.js